export const combineAlphanumericCharacters =
  /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d!?_+*'"`#¥|$%&\-^\\@;:,./=~|[\](){}<>]{1,}$/;
